<template>
    <section class="">
        <div class="container youtube ">
            <figure class="image is-16by9">
                <iframe  id="ytplayer1" class="has-ratio" width="100%" height="auto" src="https://www.youtube.com/embed/vINpCPIr6tQ?rel=0&enablejsapi=1&controls=0&showinfo=0&loop=1&playlist=vINpCPIr6tQ&iv_load_policy=3"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen controls></iframe>
            </figure>
            <img id="muteButton" :src=muteButtonSrc @click="muteUnmuteVideoYoutube()">
            <div id="overlayForSwipe"></div>    
        </div>    
    </section>
</template>


<script>

export default {
    name: "YoutubePlayer",
    data() {
        return {
            youtubePlayer: null,
            videoIsPlaying: false,
            muteButtonSrc: require('../assets/images/volume_off_black_24dp.svg')
        };
    },
    mounted() {
        window.addEventListener('load', () => {
            this.onYouTubeIframeAPIReady();
            window.addEventListener('scroll', this.onPlayerReady);
        })

        
    },
    // destroyed() {
    //     window.removeEventListener("scroll", this.onPlayerReady);
    // },
    methods: {
        onYouTubeIframeAPIReady() {
            this.youtubePlayer = new YT.Player('ytplayer1', {
                events: {
                    // 'onReady': this.onPlayerReady()
                },
                loop: 1
            });  
        
        },
        muteUnmuteVideoYoutube() {
            // console.log('mute click')
            // var muteUnMuteeButton = document.querySelector("#muteButton img");

            if (this.youtubePlayer.isMuted()) {
                this.youtubePlayer.unMute();
                this.muteButtonSrc = require("../assets/images/volume_mute_black_24dp.svg");

            } else {
                this.youtubePlayer.mute();
                this.muteButtonSrc = require("../assets/images/volume_off_black_24dp.svg");
            }
        },
        onPlayerReady() {
            // console.log('this.youtubePlayer',this.youtubePlayer)
            if (window.scrollY >= 10 && this.videoIsPlaying == false) { 
                this.youtubePlayer.mute();
                this.youtubePlayer.playVideo();
                this.videoIsPlaying = true;
            }
        }  
    },
    // computed: {
    //     muteButtonSrc: {
    //         get() {
    //             return '../assets/images/volume_off_black_24dp.svg';
    //         },            
    //         set(newValue) {
    //             this.muteButtonSrc = newValue 
    //         }
    //     }
    // }
}
</script>

<style lang="scss">
.container.youtube {
    margin-top: 3rem;
}
//Landing page
#muteButton {
    position: absolute;
    bottom: 3rem;
    right: 3rem;
    min-width: 3rem;
    z-index: 100;
    max-width: 5rem;
    cursor: pointer;
    @media (max-width: 768px) {
        min-width: 2rem;
        max-width: 2rem;
        bottom: 2rem;
        right: 2rem;
    }
}

#overlayForSwipe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
}

</style>
